import {AbstractSearchCriteria} from './abstract-search-criteria';

export class ProductDetailsSearchCriteria extends AbstractSearchCriteria {
    productCode = '';
    serviceType = '';
}
